import { Component, Input, OnInit, AfterViewInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Step12 } from '../../../../shared/models/component-messages/mapaIN/step12';
import { AutoCompleteService } from '../../../../shared/services/auto-complete.service';
import { CTRL_40 } from '../../../validators/40/ctrl40';
import { TypeAdresse } from '../models/TypeAdresse';
import { MapaINControlNames } from '../service/mapaINControleNames';
import { CTRL_2000 } from '../../../validators/newRG/2000/ctrl2000';
import { CTRL_2001 } from '../../../validators/newRG/2001/ctrl2001';
import { CTRL_2002 } from '../../../validators/newRG/2002/ctrl2002';
import { AvisDataTransferService } from '../../../../shared/services/avis-data-transfer.service';
@Component({
  selector: 'app-type-adresse',
  templateUrl: './type-adresse.component.html'
})
export class TypeAdresseComponent implements OnInit, AfterViewInit {

  @Input() uid = '';
  public current_uid = 'TypeAdresse';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;

	@Input() adr: TypeAdresse;

	public rg3 = CTRL_40.id + '_';
  public rg4 = CTRL_40.id + '_e_';
  public rg5 = CTRL_2000.id + '_';
  public rg6 = CTRL_2001.id + '_';
  public rg7 = CTRL_2002.id + '_';
  public rg8 = CTRL_2000.id + '_e_';
  public rg9 = CTRL_2001.id + '_e_';
  public rg10 = CTRL_2002.id + '_e_';

  public paysCtrName: string;

  public step12 = new Step12();
	public optionsSelect: any[];
  public optionsSelectType = 'PAYS';
  @Input() filtreRG: string;
	@Input() nbIteration: number;
  isFrance: boolean;

	constructor(private autoCompleteService: AutoCompleteService, private avisDataTransferService:AvisDataTransferService) { }

	public ngOnInit() {
		this.optionsSelect = this.autoCompleteService.getOptions(this.optionsSelectType);
    this.paysCtrName = this.getUid() + '_SepAtt_pays';
    if (this.adr) {
      if (this.adr.pays === null || this.adr.pays === 'FR') {
        this.adr.pays = '';
      }
    }
    this.isFr();
  }

  ngAfterViewInit() {
    this.researchFormOnChangeDetecte();
  }

  researchFormOnChangeDetecte(){
    const control = this.parentForm.get(this.paysCtrName);
    if (control) {
      control.valueChanges.subscribe(value => {
        if (this.adr) {
          this.adr.pays = value;
        }
        this.isFr();
      });
    }
  }


  isFr() {
    this.isFrance = this.parentForm.controls[this.paysCtrName] ?
                    (this.parentForm.controls[this.paysCtrName].value === '' || this.parentForm.controls[this.paysCtrName].value === null || this.parentForm.controls[this.paysCtrName].value === 'FR') :
                    this.adr ? (this.adr.pays === '' || this.adr.pays === null || this.adr.pays === 'FR') : true;
		if (this.isFrance) {
      this.parentForm.addControl(this.getStepId() + this.rg3 + this.filtreRG + (this.nbIteration + 1), new FormControl({ rgCtrls: MapaINControlNames.getCtrl_40Names_json(this.filtreRG, this.nbIteration + 1) }));
			this.parentForm.addControl(this.getStepId() + this.rg5 + this.filtreRG + (this.nbIteration + 1), new FormControl({ rgCtrls: MapaINControlNames.getCtrl_1Names_json(this.filtreRG, this.nbIteration + 1) }));
      this.parentForm.addControl(this.getStepId() + this.rg6 + this.filtreRG + (this.nbIteration + 1), new FormControl({ rgCtrls: MapaINControlNames.getCtrl_1Names_json(this.filtreRG, this.nbIteration + 1) }));
      this.parentForm.addControl(this.getStepId() + this.rg7 + this.filtreRG + (this.nbIteration + 1), new FormControl({ rgCtrls: MapaINControlNames.getCtrl_1Names_json(this.filtreRG, this.nbIteration + 1) }));
		} else {
      this.parentForm.addControl(this.getStepId() + this.rg4 + this.filtreRG + (this.nbIteration + 1), new FormControl({ rgCtrls: MapaINControlNames.getCtrl_40_voieeNames_json(this.filtreRG, this.nbIteration + 1) }));
      this.parentForm.addControl(this.getStepId() + this.rg8 + this.filtreRG + (this.nbIteration + 1), new FormControl({ rgCtrls: MapaINControlNames.getCtrl_1_voieeNames_json(this.filtreRG, this.nbIteration + 1) }));
      this.parentForm.addControl(this.getStepId() + this.rg9 + this.filtreRG + (this.nbIteration + 1), new FormControl({ rgCtrls: MapaINControlNames.getCtrl_1_voieeNames_json(this.filtreRG, this.nbIteration + 1) }));
      this.parentForm.addControl(this.getStepId() + this.rg10 + this.filtreRG + (this.nbIteration + 1), new FormControl({ rgCtrls: MapaINControlNames.getCtrl_1_voieeNames_json(this.filtreRG, this.nbIteration + 1) }));
    }

	}


  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }

  getStepId() {
    return this.uid.substring(0, this.uid.indexOf("SepSep"));
  }


}

